import { merge } from '../../helper';

import * as exElement from '../element';

import * as exContextMenu from './contextMenu';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // --------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (context menu)
    const elContextMenu = exElement.create({
        merge: defConfig,
        tag: 'ul',
        class: {
            new: 'context-menu context-menu-list',
        },
        style: {
            display: 'none',
        },
    });
    elements.element = elContextMenu;

    // --------------------------------------------------------------------

    // Create element (context menu items)
    const contextMenuItems = exContextMenu.data(elContextMenu, {
        merge: exElement.clear({ ...defConfig }),
    });
    elements.items = contextMenuItems;

    // --------------------------------------------------------------------

    // Return
    return elements;
}

// ------------------------------------------------------------------------

export { create };
